
import Vue from 'vue'
import { Component, Prop } from 'nuxt-property-decorator'
import { Section } from 'fsxa-api'
import { FSXARenderContentElement } from 'fsxa-pattern-library'

@Component({
  name: 'LocationContent',
  components: { FSXARenderContentElement },
})
export default class LocationContent extends Vue {
  @Prop({ default: () => [] }) locationDefaultContents! : Section[]

  @Prop({ default: () => [] }) locationSpecificContents! : Section[]

  @Prop({ default: () => [] }) locationTypeSpecificContents! : Section[]

  private get content () : Section[] {
    if (this.locationSpecificContents.length) return this.locationSpecificContents
    if (this.locationTypeSpecificContents.length) return this.locationTypeSpecificContents
    return this.locationDefaultContents
  }
}
